<template>
    <div class="form-page">
        <my-form v-model="form" @submit="submitHandler" table>
            <my-form-item-group title="异议或投诉信息">
                <el-form-item label="投诉单位" prop="tsdwname" class="table-full-row">
                    {{form.tsdwname||'-'}}
                </el-form-item>
                 <el-form-item label="提交时间" class="table-full-row">
                    {{form.tjtime||'-'}}
                </el-form-item>
                <el-form-item label="投诉内容" prop="tscontent"  class="table-full-row">
                    {{form.tscontent||'-'}}
                </el-form-item>
                <el-form-item label="理由依据" prop="lyyj"  class="table-full-row">
                    {{form.lyyj||'-'}}
                </el-form-item>
               
               <el-form-item label="附件" class="table-full-row">
                    <my-upload readonly  :file-guid="form.fileguid"></my-upload>
                </el-form-item> 
            </my-form-item-group>
            <my-form-item-group title="受理异议或投诉" v-if="form.exthfbj===null||form.exthfbj==='0'">
                <el-form-item label="投诉受理人" prop="tsslr" class="table-full-row" :rules="newRule('投诉受理人', 'required')">
                     <el-input v-model="form.tsslr"  type="textarea" :rows="4"></el-input>
                </el-form-item>
                <el-form-item label="受理时间" prop="sltime" class="table-full-row" :rules="newRule('受理时间', 'required')">
                    <el-date-picker v-model="form.sltime" value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择日期时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="处理结果"   prop="txthfcontent" class="table-full-row" :rules="newRule('处理结果', 'required')">
                    <ueditor v-model="form.txthfcontent"></ueditor>
                </el-form-item>
                <el-form-item label="附件" class="table-full-row">
                    <my-upload :file-guid="form.by5|| ''"></my-upload>
                </el-form-item>
            </my-form-item-group>
            <my-form-item-group title="受理异议或投诉" v-else>
                <el-form-item label="投诉受理人" prop="tsslr" class="table-full-row">
                    {{form.tsslr||'-'}}
                </el-form-item>
                <el-form-item label="受理时间" class="table-full-row">
                    {{form.sltime||'-'}}
                </el-form-item>
                <el-form-item label="历史处理" prop="clresult" class="table-full-row">
                    <el-input v-html="form.clresult" type="textarea"></el-input>
                </el-form-item>
                <el-form-item label="追加处理" prop="txthfcontent" class="table-full-row" :rules="newRule('追加回复内容', 'required')">
                    <ueditor v-model="form.txthfcontent"></ueditor>
                </el-form-item>
                <el-form-item label="附件" class="table-full-row">
                    <my-upload readonly :file-guid="form.by5|| ''"></my-upload>
                </el-form-item>
            </my-form-item-group>
            <template slot="btn" class="btn" slot-scope="scope">
                <el-button icon="el-icon-circle-check" type="primary" @click="fSave('0',scope.submitHandler)">
                   回复
                </el-button>
            </template>
        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";
export default {
    mixins: [FORM_PAGE_MIXIN],
    data() {
        return{
            tableData:[],
            dialogVisible:false,
            form:{
                shbj:'',
                fileguid:'',
                by5:'',
                sltime:''
            },        
            pgData:{
                procode:'',
                sortname:'tscode',
                pageindex:'1',
                sortorder:'desc',
                pagesize:'20'
            },
            
        }
    },
    computed: {

    },
    watch: {

    },
    methods: {
        // 提交
        fSave:function(id,cb){           
            this.form.shbj=id;
            cb()
        },
        submitHandler:function(){
            var that=this
            that.$post(`${this.getGetters('bidUrl')}/bidding/yygl/tsadd.json`,
             this.form,
             (data, res) => {
                   ShowMsg(res.msg,'success')
                   this.cancleHandler();
            });
        },
    },
    created() {
       this.jspInit(`${this.getGetters('bidUrl')}/bidding/yygl/tsedit.json`,{
           procode:this.getQuery('procode'),
           id:this.getQuery('id'),
        }, (data) => {
            var form = data.jsonmodel;
            form.by5 = data.by5;
            this.form = form;
        });
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
